const calculateTimeDelta = (startTime, endTime) => {
  const fromTimestamp = startTime.getTime();
  const endTimestamp = endTime.getTime();
  const durationInMs = endTimestamp - fromTimestamp;
  const durationInSecond = Math.max(0, Math.round(durationInMs / 1e3));
  return {
    milliseconds: durationInMs,
    days: Math.floor(durationInSecond / (3600 * 24)),
    hours: Math.floor(durationInSecond / 3600 % 24),
    minutes: Math.floor(durationInSecond / 60 % 60),
    seconds: Math.floor(durationInSecond % 60)
  };
};

export { calculateTimeDelta };
